import React from 'react';
import { useCookies } from '../contexts/CookieContext';
import { useLanguage } from '../contexts/LanguageContext';

const CookieBanner = () => {
  const {
    showBanner,
    acceptAllCookies,
    rejectAllCookies,
    openPreferences
  } = useCookies();
  const { t } = useLanguage();

  if (!showBanner) return null;

  return (
    <>
      <div className="fixed inset-0 z-40 bg-black/[0.62]" />

      <div className="fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-[#0b0b0f]/[0.96] shadow-2xl shadow-black/70 backdrop-blur-xl">
        <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
          <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
            <div className="flex-1">
              <div className="flex items-start gap-4">
                <div className="mt-1 flex h-8 w-8 shrink-0 items-center justify-center rounded-md border border-white/10 bg-white/[0.06] text-[#0a84ae]">
                  <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>

                <div className="flex-1">
                  <h3 className="mb-2 text-lg font-normal text-white">
                    {t('cookies.bannerTitle')}
                  </h3>
                  <p className="max-w-3xl text-sm leading-6 text-[#b7b5c2]">
                    {t('cookies.bannerDescription')}
                  </p>
                </div>
              </div>
            </div>

            <div className="flex flex-col gap-3 sm:flex-row lg:shrink-0">
              <button
                onClick={rejectAllCookies}
                className="min-h-[42px] rounded-md border border-white/10 bg-white/[0.04] px-5 text-sm font-medium text-[#d7d6de] transition-colors duration-200 hover:bg-white/[0.08] hover:text-white"
              >
                {t('cookies.rejectAll')}
              </button>

              <button
                onClick={openPreferences}
                className="min-h-[42px] rounded-md border border-[#0a84ae]/40 bg-[#0a84ae]/10 px-5 text-sm font-medium text-[#c6efff] transition-colors duration-200 hover:bg-[#0a84ae]/[0.16]"
              >
                {t('cookies.customize')}
              </button>

              <button
                onClick={acceptAllCookies}
                className="min-h-[42px] rounded-md bg-white px-5 text-sm font-medium text-black shadow-[inset_0_-12px_20px_rgba(255,255,255,0.45),0_4px_14px_rgba(255,255,255,0.14)]"
              >
                {t('cookies.acceptAll')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CookieBanner;
